import React, { useRef } from "react";
import { sample } from "lodash";
import {
  Wrapper,
  Top,
  Score,
  ScoreTop,
  ScoreBottom,
  ResultTitle,
  ResultDescription,
  Additional,
  ShareWrapper,
  ShareLabel,
  ShareButton,
  ShareButtonsWrapper,
  Button,
  TopInner,
  ShareRight,
  GameoverWrapper,
  GameoverTitle,
  GameoverPic,
  LoseText,
  LoseButtonWrapper,
  LoseButton
} from "./styled";
import pluralize from "../utils/pluralize";
import results from "../results";

const social = ["fb", "vk", "tw", "tg"];

const SHARING_SERVICE = {
  fb: "https://www.facebook.com/sharer/sharer.php?u=",
  vk: "https://vk.com/share.php?url=",
  tw: "http://twitter.com/intent/tweet?url=",
  tg: "https://telegram.me/share/url?url="
};

const SHARE_URL = `https://donate.dissernet.org/game/share/`;

function Result({ score, sad, onNext, onRepeat }) {
  let categoryIndex = 0;
  if (score >= 11) categoryIndex = 1;
  if (score >= 16) categoryIndex = 2;

  const currentResult = results[categoryIndex];
  const descriptionRandom = useRef(sample(currentResult.additional));

  const handleShare = service => {
    window.open(`${SHARING_SERVICE[service]}${SHARE_URL}${score}`, "_blank");
  };

  return (
    <Wrapper>
      {sad ? (
        <GameoverWrapper>
          <GameoverTitle>
            Увы, время вышло, а вы не проверили ни одного текстового фрагмента
          </GameoverTitle>
          <GameoverPic />
          <LoseText>Вы проиграли</LoseText>
          <LoseButtonWrapper>
            <LoseButton onClick={onRepeat}>Перезапуск</LoseButton>
          </LoseButtonWrapper>
        </GameoverWrapper>
      ) : (
        <>
          <Top>
            <TopInner>
              <Score>
                <ScoreTop>{score}</ScoreTop>
                <ScoreBottom>
                  {pluralize(score, "балл", "балла", "баллов")}
                </ScoreBottom>
              </Score>
              <ResultTitle>{currentResult.text}</ResultTitle>
              <ResultDescription>{currentResult.description}</ResultDescription>
              <Additional
                dangerouslySetInnerHTML={{ __html: descriptionRandom.current }}
              />
            </TopInner>
          </Top>
          <ShareWrapper>
            <ShareRight>
              <ShareLabel>Поделиться в соц.сетях</ShareLabel>
              <ShareButtonsWrapper>
                {social.map(key => (
                  <ShareButton
                    key={key}
                    k={key}
                    onClick={() => handleShare(key)}
                  />
                ))}
              </ShareButtonsWrapper>
            </ShareRight>
            <Button
              href="http://donate.dissernet.org/land/store/game/263"
              target="_blank"
            >
              Помочь Диссернету!
            </Button>
          </ShareWrapper>
        </>
      )}
    </Wrapper>
  );
}

export default Result;
